/**
 * Expired Page - Shown when token has expired
 */

export function ExpiredPage() {
  return (
    <div className="expired-page">
      <div className="expired-content">
        <div className="expired-icon">⏰</div>
        <h1>Link Expired</h1>
        <p className="expired-message">
          This property visit form link has expired for security reasons.
        </p>

        <div className="expired-info">
          <h2>What can I do?</h2>
          <ul>
            <li>Check your email for a more recent link</li>
            <li>Contact support to request a new link</li>
            <li>
              Call or text <strong>1-469-949-3347</strong> for assistance
            </li>
          </ul>
        </div>

        <div className="expired-note">
          <strong>Security Note:</strong> Form links expire after a set period to protect sensitive
          property information.
        </div>
      </div>
    </div>
  );
}
